import React, {useState, useEffect} from 'react';
import Loading from './Loading'
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import { numberFormat } from './Investor'




function Home(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Invest with the best";
    const [pageData, setpageData] = useState({});
    const [param, setParam] = useState("su");
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/super-investors?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;

        const cdresponse = await axiosPrivate.get(url);

        let tempData = cdresponse.data
        tempData.groups.forEach(item => (
            item.rows.sort(dynamicSortDescending("total_investments"))
        ))
        let finalData = JSON.parse(JSON.stringify(tempData))
        finalData.groups = []
        if (param ==="su") {
            tempData.groups.forEach(item => {
                if (item.name === "Superinvestors") {
                    finalData.groups.push(item)
                }
            })
        }
        if (param === "pr") {
            tempData.groups.forEach(item => {
                if (item.name === "Promoters") {
                    finalData.groups.push(item)
                }
            })
        }
        if (param === "id") {
            tempData.groups.forEach(item => {
                if (item.name === "Institutions Domestic") {
                    finalData.groups.push(item)
                }
            })
        }
        if (param === "if") {
            tempData.groups.forEach(item => {
                if (item.name === "Institutions Foreign") {
                    finalData.groups.push(item)
                }
            })
        }
        setpageData(finalData)

        /*let tempData = cdresponse.data
        tempData.groups.forEach(item => (
            item.rows.sort(dynamicSortDescending("total_investments"))
            ))
        setpageData(tempData)*/
    }
    const getUrl = (url) => {
        return "/Investor/" + url
    }
    const getCompanyUrl = (url) => {
        return "/CompanyInvestor/" + url
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            console.log(a[property])
            console.log(b[property])
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }

    useEffect(() => {
        companyDetails()
    }, [param])
    

    return (
        <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "14px", minHeight: "650px", marginLeft: "10px", marginRight: "10px", paddingBottom: "110px", paddingTop: "90px" }}>
            <div style={{ padding: "5px 110px" }}>
                <div className="CompanyNav" style={{ padding: "10px 0px 0px 0px" }}>

                    <div className="CompanyMenu" id="current" onClick={() => {
                        setParam('su')
                    }
                    } style={param === "su" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Superinvestors</div>
                    <div className="CompanyMenu" id="Activity" onClick={() => {
                        setParam('pr')
                    }
                    } style={param === "pr" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Promoters</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('id')
                    }
                    } style={param === "id" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Institutions Domestic</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        setParam('if')
                    }
                    } style={param === "if" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor:"rgb(221, 219, 240)", color: '#3e424b' }}>Institutions Foreign</div>

                </div>
            </div>    
            <div>
            {Object.keys(pageData).length > 0 && pageData.groups.map(groupItem =>(
                <div style={{ padding: "10px 110px 30px 110px" }}>
                    
                    <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "10px" }}>
                        <div className="AboutHeaderTop" style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                            {/*<div className="SuperHeader" style={{ textAlign: "left", padding: "10px 5px", fontSize: "20px", fontWeight: "600"}}>
                                {groupItem.name}
                            </div>*/}
                        </div>
                        <table className="PeersTable finData" style={{width:"100%"}}>
                            <tbody>
                                <tr>
                                    <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left", paddingLeft: "10px", fontWeight: "500" }}>Investors</td>
                                    <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>No of Stocks</td>
                                    <td className="columnHeading" style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>Investment Value (Cr)</td>
                                    <td className="columnHeading" style={{ textAlign: "left", paddingLeft: "10px", fontWeight: "500" }}>Top 10 Holdings (left to right)</td>
                                </tr>
                            </tbody>
                            <tbody>
                                {groupItem.rows.map((dataKey, index) => (
                                    <tr>
                                        <td className={index % 2 ===0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "left", paddingLeft: "10px" }}><a href={getUrl(dataKey.id)} target="_blank" style={{ textDecoration: "none" }}>{dataKey.name}</a></td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{dataKey.investments?.length}</td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap", textAlign: "center" }}>{numberFormat(dataKey.total_investments)}</td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ textAlign: "left", paddingLeft: "10px", whiteSpace: "nowrap" }}>
                                            {dataKey.top_stocks?.map(data => (
                                                <a href={getCompanyUrl(data)} target="_blank" style={{ textDecoration: "none" }}>{data} &nbsp; &nbsp;</a>
                                            ))}

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>              

                </div>

            ))}
                {Object.keys(pageData).length === 0 &&
                <div style={{ minHeight: "400px", paddingTop: "180px" }}>
                    <Loading />
                </div>
                    }
                
            </div>
        </div>
    );
}
export default Home;

